"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreConsumer = void 0;
exports.StoreProvider = StoreProvider;
var React = require("react");
var state_1 = require("./state");
function reducer(state, action) {
    switch (action.type) {
        case "FETCH_DATA":
            return __assign(__assign({}, state), { lookups: action.payload });
        case "CHANGE_PRODUCT":
            return __assign(__assign({}, state), { product: __assign({}, action.payload) });
        case "ADD_FAV":
            var items = state.favourites.length < 2 ? state.favourites : [state.favourites[0], state.favourites[1]];
            return __assign(__assign({}, state), { favourites: __spreadArray(__spreadArray([], items, true), [action.payload], false) });
        case "REMOVE_FAV":
            return __assign(__assign({}, state), { favourites: action.payload });
        case "RESET":
            return __assign(__assign({}, state), { favourites: action.payload });
        case "SET_PRODUCTS":
            return __assign({}, state);
        case "SET_PRODUCTGROUP":
            return __assign(__assign({}, state), { selectedState: action.payload });
        case "SET_PRODUCT":
            return __assign(__assign({}, state), { product: action.payload });
        case "SET_MAIN_PRODUCT":
            return __assign(__assign({}, state), { mainProduct: __assign(__assign({}, state.mainProduct), action.payload) });
        case "SET_BEVERAGE_IMAGE":
            return __assign(__assign({}, state), { imageData: action.payload });
        case "MARK_ALL_NO":
            return __assign(__assign({}, state), { allergenData: action.payload });
        default:
            return state;
    }
}
function StoreProvider(props) {
    var _a = React.useReducer(props.reducer || reducer, props.state), state = _a[0], dispatch = _a[1];
    var value = { state: state, dispatch: dispatch };
    var val = value;
    return React.createElement(state_1.Store.Provider, { value: val }, props.children);
}
var StoreConsumer = state_1.Store.Consumer;
exports.StoreConsumer = StoreConsumer;
